/** Collections created via the DB layer to bypass upload / hook constraints during duplication. */
export const DB_CREATE_COLLECTIONS = new Set(['media']);

/**
 * Collections with self-referential relationships that need a create pass (refs stripped)
 * followed by an update pass once all documents in the collection exist in the ID map.
 */
export const SELF_REF_TWO_PASS_COLLECTIONS = new Set(['linked-modals']);

/** Collections we never copy; relationship targets here are set to null when remapping. */
export const EXCLUDED_COLLECTION_SLUGS = new Set(['data-ingestion', 'preview', 'publish', 'tenants', 'users']);

/** Order of collections for duplication (dependencies first). */
export const DUPLICATION_PHASES = [
  ['media'],
  ['deploys'],
  ['utm', 'city', 'countdown', 'form', 'multi-destination-cta', 'linked-modals', 'advanced-map-markers-group'],
  [
    'custom-module',
    'intro',
    'business',
    'info',
    'html',
    'hero',
    'city-selector-near-search',
    'map-interactive',
    'video',
    'faqs',
    'footer',
    'gallery',
    'giftcard',
    'city-selector',
    'header',
    'experience',
    'location',
    'popup',
    'instafeed',
    'banner',
    'banner-loop',
    'tickets',
    'reveal-content',
    'advanced-map',
    'headline',
    'reviews',
    'watchpage',
    'press',
    'video-slider',
    'grid',
    'tabs',
    'cookies',
    'regions',
  ],
  ['pages'],
  ['styles'],
  ['settings'],
] as const;

/** Flattened list of all collection slugs we duplicate, in order. */
export const ALL_DUPLICATABLE_COLLECTIONS = DUPLICATION_PHASES.flat();
